// Lifted from useMatrixTableColumns; pure so basic-output can reuse without React/Jotai.

import * as R from 'remeda'

import { type Question } from '~/hooks/useSurveyQuery'
import { type ColumnInfo, getDiffKey } from '~/utils'

import {
  getColumnInfos,
  type QuestionsDiff,
  type QuestionsDiffsMap,
} from './common'
import { type MatrixColumnKey } from './matrix'

const widthMap: Record<MatrixColumnKey, string> = {
  answerText: 'max-content',
}

export const buildMatrixTableColumns = ({
  hiddenColumnKeys,
  question,
  questionsDiffsMap,
}: {
  hiddenColumnKeys: ReadonlyArray<MatrixColumnKey>
  question: Pick<Question, 'mt_questions' | 'question_id'>
  questionsDiffsMap: QuestionsDiffsMap
}): ColumnInfo<MatrixColumnKey>[] => {
  const questionsDiffs: ReadonlyArray<QuestionsDiff> =
    questionsDiffsMap[question.question_id] ?? []
  const columnKeys: MatrixColumnKey[] = R.difference(
    ['answerText', ...question.mt_questions, ...questionsDiffs.map(getDiffKey)],
    hiddenColumnKeys,
  )

  return getColumnInfos(columnKeys, widthMap)
}
